import React from "react";
import { twClassNames } from "../helpers/twClassNames";

interface DividerProps {
    text?: string;
    className?: string;
    hideLeft?: boolean;
    hideRight?: boolean;
}

export function Divider({ text, className, hideLeft, hideRight }: DividerProps) {
    if (text) {
        return (
            <div
                className={twClassNames(
                    "flex flex-shrink-0 flex-row items-center gap-4 whitespace-nowrap font-mono text-xs",
                    className
                )}
            >
                {!hideLeft && <div className="h-px w-full bg-divider" />}
                <p>{text}</p>
                {!hideRight && <div className="h-px w-full bg-divider" />}
            </div>
        ) as React.ReactElement;
    }
    return (
        <div className={twClassNames("h-px w-full flex-shrink-0 bg-divider", className)} />
    ) as React.ReactElement;
}
